export const sumakomiMain = () => {

    /* ------------------------------------------------------------------------------
    *
    * Google Maps API
    *
    -----------------------------------------------------------------------------*/
    var script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyD7p_wC4B9Rsu3evlI6vfaYRte-y4pMgbg&callback=initMap';
    script.async = true;

    /* ------------------------------------------------------------------------------
     *
     * Setting
     *
     -----------------------------------------------------------------------------*/

    let G_MAP = null;
    let G_CIRCLE = null;
    let G_GEOCODER = null;

    // *初期座標 未設定なら大阪市中央区
    const DEFAULT_LAT = null;
    const DEFAULT_LNG = null;

    // 初期半径 未設定なら1500m
    const DEFAULT_RADIUS = 1500;
    // 最小半径
    const MIN_RADIUS = 100;
    // 最大半径
    const MAX_RADIUS = 10000;

    /* ------------------------------------------------------------------------------
     *
     * initMap / API実行（マップ生成等）
     *
     -----------------------------------------------------------------------------*/


    window.initMap = function () {
        // MAP
        G_MAP = new CustomMap({
            lat: DEFAULT_LAT,
            lng: DEFAULT_LNG,
        });

        // CIRCLE
        G_CIRCLE = new CustomCircle({
            lat: DEFAULT_LAT,
            lng: DEFAULT_LNG,
            radius: DEFAULT_RADIUS,
            map: G_MAP.getMap
        });

        // G_GEOCODER
        G_GEOCODER = new CustomGeocoder({
            map: G_MAP.getMap,
            marker: G_MAP.getMapMarker,
            circle: G_CIRCLE.getCircle
        });

        run();

    }

    /* ------------------------------------------------------------------------------
     *
     * Run / 追加処理
     *
     -----------------------------------------------------------------------------*/

    function run() {



        // 初期化
        const _map = G_MAP.getMap;
        const _circle = G_CIRCLE.getCircle;
        const _geocoder = G_GEOCODER;

        /* ------------------------------------------------------------------------------
        *
        * 画面が読み込まれた時の初めの処理
        *
        -----------------------------------------------------------------------------*/
        if ($('#map').length && $('input[name="adress"]').data('initArea') !== "") {
            _geocoder.search($('input[name="adress"]').data('initArea'));
            $('.js-set--sumakomi-adress').val($('input[name="adress"]').data('initArea')); // form-calTotalに値セット
        }
        if ($('#map').length && $('input[name="distance"]').data('initDistance') !== "") {
            // 初期値をセット
            var radius_val = Number($('input[name="distance"]').data('initDistance'));
            $('input[name="distance"]').val(radius_val);
            _circle.setRadius(radius_val);
            $('.js-set--sumakomi-distance').val(radius_val); // form-calTotalに値セット
        } else {
            $('input[name="distance"]').val(DEFAULT_RADIUS);
            $('.js-set--sumakomi-distance').val(DEFAULT_RADIUS); // form-calTotalに値セット
        }

        // マップクリックイベントハンドラー
        _map.addListener('click', function (e) {
            _map.panTo(e.latLng);
            _circle.setCenter(e.latLng);
        });

        // サークル座標変更イベントハンドラー
        _circle.addListener("center_changed", function (e) {
            // サークルの中央を座標を変更
            var center = _circle.getCenter();
            // 緯度経度から住所を取得
            var centerLat = center.lat();
            var centerLng = center.lng();
            var currentLocation = new google.maps.LatLng(centerLat, centerLng);
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ 'latLng': currentLocation }, function (results, state) {
                //取得に成功
                if (state == google.maps.GeocoderStatus.OK) {
                    var adressArr = results[0].address_components;
                    adressArr.reverse();
                    adressArr.splice(0, 2);
                    var adressTxt = "";
                    adressArr.forEach((adress) => {
                        adressTxt += adress.long_name;
                    });
                    $('input[name="adress"]').val(adressTxt);
                    $('.js-set--sumakomi-area').val(adressTxt); // form-calTotalに値セット
                }
            })
        });

        // サークル半径変更イベントハンドラー
        _circle.addListener("radius_changed", function (e) {
            // 半径取得
            var radius_val = _circle.getRadius();
            // 半径更新
            $("#distance").val(Math.ceil(radius_val));
            $('input[name="distance"]').val(Math.ceil(radius_val));
            $('.js-set--sumakomi-distance').val(Math.ceil(radius_val)); // form-calTotalに値セット
        });


        // 住所を変更してエンターを押下したときの処理
        $(document).on('keyup', 'input[name="adress"]', function (e) {
            $('.js-set--sumakomi-area').val($('input[name="adress"]').val()); // form-calTotalに値セット
            if (e.keyCode === 13) {
                var adress = $('input[name="adress"]').val();
                $('.js-set--sumakomi-area').val(adress); // form-calTotalに値セット
                _geocoder.search(adress);
            }
        });

        // 検索ボタンを押したときの処理
        $(document).on('click', '.js-geocode', () => {
            var adress = $('input[name="adress"]').val();
            $('.js-set--sumakomi-area').val(adress); // form-calTotalに値セット
            _geocoder.search(adress);
        });

        /* ------------------------------------------------------------------------------
        *
        * modalで要素を選択したときの処理
        *
        -----------------------------------------------------------------------------*/
        $(".js-click").on('click', function () {
            switch ($(this).data('item')) {
                // サークルの半径選択したときの処理
                case 'distance':
                    $('input[name="distance"]').val($(this).data('distance'));
                    $('#overlay, .distance-modal').fadeOut();
                    $('body').removeClass('modal-active');  // 本文の縦スクロールを有効

                    _circle.setRadius(Number($(this).data('distance')));
                    $('.js-set--sumakomi-distance').val(Number($(this).data('distance'))); // form-calTotalに値セット
                    break;
            }
        });

    }

    // マップ要素が存在するとき
    if ($('#map').length) {
        document.head.appendChild(script);
    }
}
